class RS6Detail {
  constructor () {
    this.init()
  }

  init () {
    console.log('RS6Detail init')
    this.bindEvents()
  }

  bindEvents () {
    const textContainers = document.querySelectorAll(
      '.img-and-text-text .RS6DTL__feature-text'
    )

    textContainers.forEach(textContainer => {
      textContainer.addEventListener('click', () => {
        this.switchContent(textContainer)
      })
    })
  }

  switchContent (clickedElement) {
    // 找到当前点击元素的父容器
    const parentContainer =
      clickedElement.closest('.img-and-text-text').parentElement

    // 只在这个父容器内操作
    const allMedias = parentContainer.querySelectorAll('.RS6DTL__feature-media')
    const allTexts = parentContainer.querySelectorAll('.RS6DTL__feature-text')

    // 获取当前点击元素在父容器内的索引
    const index = Array.from(allTexts).indexOf(clickedElement)

    allMedias.forEach(media => media.classList.remove('active'))
    allTexts.forEach(text => text.classList.remove('active'))

    allMedias[index].classList.add('active')
    allTexts[index].classList.add('active')
  }
}

new RS6Detail()
